import { initializeApp } from "firebase/app";
import {
  addDoc,
  collection,
  getFirestore,
  serverTimestamp,
  doc,
  deleteDoc,
  getDocs,
} from "firebase/firestore";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";
import localforage from "localforage";

const firebaseConfig = {
  apiKey: "AIzaSyAd6CDEVQ9qEUDVhBShK54i4ybNAWpMea4",
  authDomain: "workingdom-admin.firebaseapp.com",
  projectId: "workingdom-admin",
  storageBucket: "workingdom-admin.appspot.com",
  messagingSenderId: "750018929198",
  appId: "1:750018929198:web:3cf2b76e5e284fc9fc75bf",
};

const firebaseConfigFrontend = {
  apiKey: "AIzaSyDBfOczA52scZgI0mv1XBLsugZrqgzyDDg",
  authDomain: "workingdom-frontend.firebaseapp.com",
  projectId: "workingdom-frontend",
  storageBucket: "workingdom-frontend.appspot.com",
  messagingSenderId: "368920725735",
  appId: "1:368920725735:web:956cec35d871589e757a42",
};
initializeApp(firebaseConfig);
const firebaseApp = initializeApp(firebaseConfigFrontend, "frontend-app");

export const db = getFirestore();

export const messaging = async () => {
  try {
    const isBrowserSupport = await isSupported();
    if (isBrowserSupport) {
      return getMessaging(firebaseApp);
    }
    console.log("Firebase not supported this browser");
    return null;
  } catch (error) {
    console.log("Err", error);
    return null;
  }
};

// const fn = async () => {
//   let res = await messaging();
//   console.log(res);
// };
// fn();

//export const messaging = isSupported() && getMessaging(firebaseApp);
// const messaging = async () => {
//   try {
//     const isBrowserSupport = await isSupported();
//     if (isBrowserSupport) {
//       return getMessaging(firebaseApp);
//     }
//     // console.log("Firebase not supported this browser");
//     return null;
//   } catch (error) {
//     console.log(error);
//     return null;
//   }
// };

export const dbFrontend = getFirestore(firebaseApp);

export const fetchToken = async () => {
  const messagingResolve = await messaging();
  return getToken(messagingResolve, {
    vapidKey:
      "BKcN7ScAMYCAa_dytHqpb08HB7oGYZ0XOD9-mq9hX0FNOUve6dTwv-pBL1ipnFY2vkGC_VVfi4AAEJc__MfoGVg",
  })
    .then(async (currentToken) => {
      if (currentToken) {
        //console.log("current token for client: ", currentToken);

        await addDoc(collection(dbFrontend, "users"), {
          token: currentToken,
          timestamp: serverTimestamp(),
        });
        // Set token in our local storage
        if (currentToken) {
          //console.log("set token in local storage");
          localforage.setItem("fcm_token", currentToken);
          return currentToken;
        }
        // Track the token -> client mapping, by sending to backend server
        // show on the UI that permission is secured
      } else {
        console.log(
          "No registration token available. Request permission to generate one."
        );
        // shows on the UI that permission is required
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
      // catch error while creating client token
    });
};

// export const onMessageListener = async () =>
// new Promise((resolve) => {
//   (async () => {
//     const messagingResolve = await messaging();
//     console.log("me", messagingResolve);
//     onMessage(messagingResolve, (payload) => {
//       console.log("On message: ", messaging, payload);
//       resolve(payload);
//     });
//   })();
// });

export const onMessageListener = () =>
  new Promise(async (resolve) => {
    try {
      const messagingResolve = await messaging();
      onMessage(messagingResolve, (payload) => {
        resolve(payload);
      });
    } catch (error) {
      console.log("ERr", error);
    }
  });

export const deleteFcmToken = async (token) => {
  const querySnapshot = await getDocs(collection(dbFrontend, "users"));
  querySnapshot.forEach(async (docs) => {
    // docs.data() is never undefined for query docs snapshots
    //console.log(docs.id, " => ", docs.data());
    if (docs.data().token === token) {
      await deleteDoc(doc(dbFrontend, "users", docs.id));
    }
  });
};
